import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../../../helpers/mainHelpers";
import "./style.less";

const AboutItemPageHeader = () => {
  return (
    <PageHeader
      className="about-item-page-header"
      title={<span className="about-item-page-header__label">Про заклад</span>}
      onBack={navigateBackHandler}
    />
  )
}

export default AboutItemPageHeader
